export default __webpack_public_path__ + "static/media/person_1.26714f32.svg";